import { ILocale } from "infrastructure/localization";
import { INotification } from "infrastructure/notification";

export interface IAppLanguageSwitchState {
  supportedLocales?: ILocale[];
  searchedLocales: ILocale[];
  isLoading?: boolean;
  notifications: INotification[];
}

export const getAppLanguageSwitchInitialState = (): IAppLanguageSwitchState => ({
  searchedLocales: [],
  notifications: []
});
